import React, { useState, useEffect } from 'react';
import recommendationDrinksAPI from '../services/recommendationDrinksAPI';

function RecommendedDrinks() {
  const [recommendationDrinks, setRecommendationDrinks] = useState([]);

  useEffect(() => {
    const fetchRecommendedDrinks = async () => {
      const getRecommendedDrinks = await recommendationDrinksAPI();
      setRecommendationDrinks(getRecommendedDrinks);
    };
    fetchRecommendedDrinks();
  }, []);

  const maxDrinks = 6;
  const initialDrinks = 0;
  const sixDrinks = recommendationDrinks.slice(initialDrinks, maxDrinks);

  return (
    <div className="recommend">
      <h2>Recommended</h2>
      <ul className="cardsRecommendedCarousel">
        {sixDrinks.map((recommendationDrink, index) => (
          <li
            className="cardRecommendedCarousel"
            data-testid={ `${index}-recomendation-card` }
            key={ index }
          >
            <img
              src={ recommendationDrink.strDrinkThumb }
              alt={ recommendationDrink.strDrink }
              width="175px"
            />
            <h3
              data-testid={ `${index}-recomendation-title` }
            >
              { recommendationDrink.strDrink }
            </h3>
            <p>{ recommendationDrink.strAlcoholic }</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default RecommendedDrinks;
